<ng-container *ngIf="showHeader">
    <img class="banner-img center-block div-print" src="https://gestionatupyme-public.s3.amazonaws.com/banner.png"
        alt="" />
</ng-container>

<mat-card class="simple-card mx-auto">
    <mat-card-content>
        <div class="row">

            <div class="col-12 d-flex justify-content-between" *ngIf="showHeader">
                <h1>Reporte Avalúo Fiscal</h1>

                <button
                    mat-flat-button
                    class="custom-button-primary no-print"
                    (click)="generatePDF()"
                    [disabled]="isPDFLoading">
                    <mat-icon aria-hidden="false" aria-label="Icono de descarga" fontIcon="get_app" class="icon-download"></mat-icon>
                    Descargar Resultado
                    <mat-icon *ngIf="isPDFLoading" iconPositionEnd>
                        <mat-spinner class="custom-white-spinner" diameter="15"></mat-spinner>
                    </mat-icon>
                </button>
            </div>

            <div class="col-12 my-3" *ngIf="showHeader">
                <mat-chip-set aria-label="Rut principal">
                    <mat-chip class="chip-rut">
                        <strong>RUT:</strong> {{content.DatosBasicosSolicitud.Rut |
                        number:'1.0-0'}}-{{content.DatosBasicosSolicitud.DV | uppercase}}
                    </mat-chip>
                </mat-chip-set>
            </div>

            <div class="col-12">

                <div class="resumen-cards no-print">
                    <mat-card class="resume-card blue-card">
                        <mat-card-content class="p-4 h-100 d-flex justify-content-between align-items-center">
                            <div class="h-100 d-flex flex-column justify-content-between">
                                <span class="resume-card-title font-weight-500">N° de propiedades</span>
                                <span class="resume-card-value">{{ numPropiedades }}</span>
                            </div>
                            <mat-icon class="card-icon d-flex align-items-center justify-content-center">home</mat-icon>
                        </mat-card-content>
                    </mat-card>

                    <mat-card class="resume-card green-card">
                        <mat-card-content class="p-4 h-100 d-flex justify-content-between align-items-center">
                            <div class="h-100 d-flex flex-column justify-content-between">
                                <span class="resume-card-title font-weight-500">Total avalúos</span>
                                <span class="resume-card-value">${{ totalAvaluos | number }}</span>
                            </div>
                            <mat-icon class="card-icon d-flex align-items-center justify-content-center">check_circle</mat-icon>
                        </mat-card-content>
                    </mat-card>
                </div>

                <mat-card class="mt-5 no-print">
                    <mat-card-header>
                        <mat-card-title class="font-size-title-card">
                            <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            <strong>Propiedades</strong>
                        </mat-card-title>
                    </mat-card-header>

                    <mat-card-content class="p-5">
                        <mat-accordion>
                            <mat-expansion-panel *ngFor="let i = index; let vivienda of viviendas">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        {{ vivienda.comuna }} {{ vivienda.numeroRol }}
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <div class="p-5 w-100">
                                    <div class="border grid p-5">
                                        <div class="font-weight-bold full-width">Información básica</div>

                                        <div class="font-weight-500">Dirección:</div>
                                        <div>{{ vivienda.direccion }}</div>

                                        <div class="font-weight-500">Destino:</div>
                                        <div>{{ vivienda.destino }}</div>
                                    </div>
                                    <div class="border grid p-5 mt-4">
                                        <div class="font-weight-bold full-width">Titular</div>

                                        <div class="font-weight-500">Nombre:</div>
                                        <div>{{ vivienda.certificado.nombreTitular }}</div>

                                        <div class="font-weight-500">Rut:</div>
                                        <div>{{ vivienda.certificado.rut }}</div>
                                    </div>
                                    <div class="border grid p-5 mt-4">
                                        <div class="font-weight-bold full-width">Avalúo</div>

                                        <div class="font-weight-500">Total Avalúo:</div>
                                        <div>${{ vivienda.certificado.price.total | number: '1.0-0' }}</div>

                                        <div class="font-weight-500">Exento Impuesto:</div>
                                        <div>${{ vivienda.certificado.price.exentoImpuesto | number: '1.0-0' }}</div>

                                        <div class="font-weight-500">Afecto Impuesto:</div>
                                        <div>${{ vivienda.certificado.price.afectoImpuesto | number: '1.0-0' }}</div>
                                    </div>
                                    <div class="border grid p-5 mt-4">
                                        <div class="font-weight-bold full-width">Superficies</div>

                                        <div class="font-weight-500">Terreno:</div>
                                        <div>{{ vivienda.certificado.superficie.terreno | number: '1.0-0' }} m²</div>

                                        <div class="font-weight-500">Contrucciones:</div>
                                        <div>{{ vivienda.certificado.superficie.construcciones | number: '1.0-0' }} m²
                                        </div>
                                    </div>
                                    <div class="border grid p-5 mt-4">
                                        <div class="font-weight-bold full-width">Bienes Comunes</div>

                                        <div class="font-weight-500">Total avalúo:</div>
                                        <div>${{ vivienda.anexo.detalle.bienesComunes.totalAvaluoBienesComunes | number:
                                            '1.0-0' }}</div>

                                        <div class="table-responsive border rounded full-width">
                                            <table mat-table
                                                [dataSource]="vivienda.anexo.detalle.bienesComunes.totalAvaluoBienesComunes === 0 ? [] : vivienda.anexo.detalle.bienesComunes.details"
                                                class="custom-print-table">
                                                <ng-container matColumnDef="rol">
                                                    <th mat-header-cell *matHeaderCellDef>ROL</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.rolBienComun }}
                                                    </td>
                                                </ng-container>

                                                <ng-container matColumnDef="tipoCopropiedad">
                                                    <th mat-header-cell *matHeaderCellDef>Tipo copropiedad</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.tipoCopropiedad }}
                                                    </td>
                                                </ng-container>

                                                <ng-container matColumnDef="total">
                                                    <th mat-header-cell *matHeaderCellDef>Total</th>
                                                    <td mat-cell *matCellDef="let element">${{ element.totalBienComun |
                                                        number: '1.0-0' }}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="prorrateoPorcentual">
                                                    <th mat-header-cell *matHeaderCellDef>Prorrateo porcentual</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.prorrateoPorcetual
                                                        }}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="avaluoProrrateado">
                                                    <th mat-header-cell *matHeaderCellDef>Avalúo prorrateado</th>
                                                    <td mat-cell *matCellDef="let element">${{ element.avaluoProrrateado
                                                        | number: '1.0-0' }}</td>
                                                </ng-container>

                                                <tr mat-header-row *matHeaderRowDef="bienesComunesDisplayedColumns">
                                                </tr>
                                                <tr mat-row
                                                    *matRowDef="let row; columns: bienesComunesDisplayedColumns;"></tr>

                                                <tr class="mat-mdc-row" *matNoDataRow>
                                                    <td class="mat-mdc-cell text-center font-weight-500"
                                                        [attr.colspan]="bienesComunesDisplayedColumns.length">
                                                        No hay datos disponibles
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="border grid p-5 mt-4">
                                        <div class="font-weight-bold full-width">Líneas de terreno</div>

                                        <div class="font-weight-500">Total avalúo:</div>
                                        <div>${{ vivienda.anexo.detalle.lineasTerreno.totalAvaluoTerreno | number:
                                            '1.0-0' }}</div>

                                        <div class="table-responsive border rounded full-width">
                                            <table mat-table
                                                [dataSource]="vivienda.anexo.detalle.lineasTerreno.totalAvaluoTerreno === 0 ? [] : vivienda.anexo.detalle.lineasTerreno.details"
                                                class="custom-print-table">
                                                <ng-container matColumnDef="linea">
                                                    <th mat-header-cell *matHeaderCellDef>Línea</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.linea }}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="superficie">
                                                    <th mat-header-cell *matHeaderCellDef>Superficie</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.superficie |
                                                        number: '1.0-0' }} m²</td>
                                                </ng-container>

                                                <ng-container matColumnDef="avaluoUnitario">
                                                    <th mat-header-cell *matHeaderCellDef>Avalúo unitario</th>
                                                    <td mat-cell *matCellDef="let element">${{ element.avaluoUnitario |
                                                        number: '1.0-0' }}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="avaluoLinea">
                                                    <th mat-header-cell *matHeaderCellDef>Avalúo línea</th>
                                                    <td mat-cell *matCellDef="let element">${{ element.avaluoLinea |
                                                        number: '1.0-0' }}</td>
                                                </ng-container>

                                                <tr mat-header-row *matHeaderRowDef="lineasTerrenoDisplayedColumns">
                                                </tr>
                                                <tr mat-row
                                                    *matRowDef="let row; columns: lineasTerrenoDisplayedColumns;"></tr>

                                                <tr class="mat-mdc-row" *matNoDataRow>
                                                    <td class="mat-mdc-cell text-center font-weight-500"
                                                        [attr.colspan]="lineasTerrenoDisplayedColumns.length">
                                                        No hay datos disponibles
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="border grid p-5 mt-4">
                                        <div class="font-weight-bold full-width">Líneas de construcción</div>

                                        <div class="font-weight-500">Total avalúo:</div>
                                        <div>${{ vivienda.anexo.detalle.lineasConstruccion.totalAvaluoConstrucciones |
                                            number: '1.0-0' }}</div>

                                        <div class="table-responsive border rounded full-width">
                                            <table mat-table
                                                [dataSource]="vivienda.anexo.detalle.lineasConstruccion.totalAvaluoConstrucciones === 0 ? [] : vivienda.anexo.detalle.lineasConstruccion.details"
                                                class="custom-print-table">
                                                <ng-container matColumnDef="linea">
                                                    <th mat-header-cell *matHeaderCellDef>Línea</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.linea }}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="clase">
                                                    <th mat-header-cell *matHeaderCellDef>Clase</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.clase }}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="calidad">
                                                    <th mat-header-cell *matHeaderCellDef>Calidad</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.calidad }}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="cantidad">
                                                    <th mat-header-cell *matHeaderCellDef>Cantidad</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.cantidad | number:
                                                        '1.0-0' }}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="anioConstruccion">
                                                    <th mat-header-cell *matHeaderCellDef>Año de construcción</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.anioConstruccion
                                                        }}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="avaluoLinea">
                                                    <th mat-header-cell *matHeaderCellDef>Avalúo linea</th>
                                                    <td mat-cell *matCellDef="let element">${{ element.avaluoLinea |
                                                        number: '1.0-0' }}</td>
                                                </ng-container>

                                                <tr mat-header-row
                                                    *matHeaderRowDef="lineasConstruccionDisplayedColumns"></tr>
                                                <tr mat-row
                                                    *matRowDef="let row; columns: lineasConstruccionDisplayedColumns;">
                                                </tr>

                                                <tr class="mat-mdc-row" *matNoDataRow>
                                                    <td class="mat-mdc-cell text-center font-weight-500"
                                                        [attr.colspan]="lineasConstruccionDisplayedColumns.length">
                                                        No hay datos disponibles
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </mat-expansion-panel>
                        </mat-accordion>
                    </mat-card-content>
                </mat-card>
            </div>

            <!-- print section -->

            <div class="col-12 div-print">
                <mat-card class="mt-5 border">
                    <mat-card-header>
                        <mat-card-title class="font-size-title-card">
                            <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            <strong>Resumen general</strong>
                        </mat-card-title>
                    </mat-card-header>

                    <mat-card-content class="p-3">
                        <div class="p-5 w-100">
                            <div class="grid border p-5">
                                <div class="grid">
                                    <div class="font-weight-500 info-text">N° de Propiedades:</div>
                                    <div class="font-weight-500 info-text">{{ numPropiedades }}</div>

                                    <div class="font-weight-500 success-text">Total avalúos:</div>
                                    <div class="font-weight-500 success-text">${{ totalAvaluos | number: '1.0-0' }}</div>
                                </div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>

                <mat-card class="mt-5">
                    <mat-card-header>
                        <mat-card-title class="font-size-title-card">
                            <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            <strong>Propiedades</strong>
                        </mat-card-title>
                    </mat-card-header>

                    <mat-card-content class="p-3">
                        <div *ngFor="let i = index; let vivienda of viviendas" class="p-5 w-100 border mb-5">
                            <div class="mb-3">
                                <mat-chip class="chip-info mr-2"><i class="fa fa-info"
                                        aria-hidden="true"></i></mat-chip>
                                <strong>{{ vivienda.comuna }} {{ vivienda.numeroRol }}</strong>
                            </div>
                            <div class="border grid p-5 no-break">
                                <div class="font-weight-bold full-width">Información básica</div>

                                <div class="font-weight-500">Dirección:</div>
                                <div>{{ vivienda.direccion }}</div>

                                <div class="font-weight-500">Destino:</div>
                                <div>{{ vivienda.destino }}</div>
                            </div>
                            <div class="border grid p-5 mt-4 no-break">
                                <div class="font-weight-bold full-width">Titular</div>

                                <div class="font-weight-500">Nombre:</div>
                                <div>{{ vivienda.certificado.nombreTitular }}</div>

                                <div class="font-weight-500">Rut:</div>
                                <div>{{ vivienda.certificado.rut }}</div>
                            </div>
                            <div class="border grid p-5 mt-4 no-break">
                                <div class="font-weight-bold full-width">Avalúo</div>

                                <div class="font-weight-500">Total Avalúo:</div>
                                <div>${{ vivienda.certificado.price.total | number: '1.0-0' }}</div>

                                <div class="font-weight-500">Exento Impuesto:</div>
                                <div>${{ vivienda.certificado.price.exentoImpuesto | number: '1.0-0' }}</div>

                                <div class="font-weight-500">Afecto Impuesto:</div>
                                <div>${{ vivienda.certificado.price.afectoImpuesto | number: '1.0-0' }}</div>
                            </div>
                            <div class="border grid p-5 mt-4 no-break">
                                <div class="font-weight-bold full-width">Superficies</div>

                                <div class="font-weight-500">Terreno:</div>
                                <div>{{ vivienda.certificado.superficie.terreno | number: '1.0-0' }} m²</div>

                                <div class="font-weight-500">Contrucciones:</div>
                                <div>{{ vivienda.certificado.superficie.construcciones | number: '1.0-0' }} m²</div>
                            </div>
                            <div class="border grid p-5 mt-4 no-break">
                                <div class="font-weight-bold full-width">Bienes Comunes</div>

                                <div class="font-weight-500">Total avalúo:</div>
                                <div>${{ vivienda.anexo.detalle.bienesComunes.totalAvaluoBienesComunes | number: '1.0-0'
                                    }}</div>

                                <div class="table-responsive border rounded full-width">
                                    <table mat-table
                                        [dataSource]="vivienda.anexo.detalle.bienesComunes.totalAvaluoBienesComunes === 0 ? [] : vivienda.anexo.detalle.bienesComunes.details"
                                        class="custom-print-table">
                                        <ng-container matColumnDef="rol">
                                            <th mat-header-cell *matHeaderCellDef>ROL</th>
                                            <td mat-cell *matCellDef="let element">{{ element.rolBienComun }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="tipoCopropiedad">
                                            <th mat-header-cell *matHeaderCellDef>Tipo copropiedad</th>
                                            <td mat-cell *matCellDef="let element">{{ element.tipoCopropiedad }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="total">
                                            <th mat-header-cell *matHeaderCellDef>Total</th>
                                            <td mat-cell *matCellDef="let element">${{ element.totalBienComun | number:
                                                '1.0-0' }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="prorrateoPorcentual">
                                            <th mat-header-cell *matHeaderCellDef>Prorrateo porcentual</th>
                                            <td mat-cell *matCellDef="let element">{{ element.prorrateoPorcetual }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="avaluoProrrateado">
                                            <th mat-header-cell *matHeaderCellDef>Avalúo prorrateado</th>
                                            <td mat-cell *matCellDef="let element">${{ element.avaluoProrrateado |
                                                number: '1.0-0' }}</td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="bienesComunesDisplayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: bienesComunesDisplayedColumns;"></tr>

                                        <tr class="mat-mdc-row" *matNoDataRow>
                                            <td class="mat-mdc-cell text-center font-weight-500"
                                                [attr.colspan]="bienesComunesDisplayedColumns.length">
                                                No hay datos disponibles
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div class="border grid p-5 mt-4 no-break">
                                <div class="font-weight-bold full-width">Líneas de terreno</div>

                                <div class="font-weight-500">Total avalúo:</div>
                                <div>${{ vivienda.anexo.detalle.lineasTerreno.totalAvaluoTerreno | number: '1.0-0' }}
                                </div>

                                <div class="table-responsive border rounded full-width">
                                    <table mat-table
                                        [dataSource]="vivienda.anexo.detalle.lineasTerreno.totalAvaluoTerreno === 0 ? [] : vivienda.anexo.detalle.lineasTerreno.details"
                                        class="custom-print-table">
                                        <ng-container matColumnDef="linea">
                                            <th mat-header-cell *matHeaderCellDef>Línea</th>
                                            <td mat-cell *matCellDef="let element">{{ element.linea }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="superficie">
                                            <th mat-header-cell *matHeaderCellDef>Superficie</th>
                                            <td mat-cell *matCellDef="let element">{{ element.superficie | number:
                                                '1.0-0' }} m²</td>
                                        </ng-container>

                                        <ng-container matColumnDef="avaluoUnitario">
                                            <th mat-header-cell *matHeaderCellDef>Avalúo unitario</th>
                                            <td mat-cell *matCellDef="let element">${{ element.avaluoUnitario | number:
                                                '1.0-0' }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="avaluoLinea">
                                            <th mat-header-cell *matHeaderCellDef>Avalúo línea</th>
                                            <td mat-cell *matCellDef="let element">${{ element.avaluoLinea | number:
                                                '1.0-0' }}</td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="lineasTerrenoDisplayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: lineasTerrenoDisplayedColumns;"></tr>

                                        <tr class="mat-mdc-row" *matNoDataRow>
                                            <td class="mat-mdc-cell text-center font-weight-500"
                                                [attr.colspan]="lineasTerrenoDisplayedColumns.length">
                                                No hay datos disponibles
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div class="border grid p-5 mt-4 no-break">
                                <div class="font-weight-bold full-width">Líneas de construcción</div>

                                <div class="font-weight-500">Total avalúo:</div>
                                <div>${{ vivienda.anexo.detalle.lineasConstruccion.totalAvaluoConstrucciones | number:
                                    '1.0-0' }}</div>

                                <div class="table-responsive border rounded full-width">
                                    <table mat-table
                                        [dataSource]="vivienda.anexo.detalle.lineasConstruccion.totalAvaluoConstrucciones === 0 ? [] : vivienda.anexo.detalle.lineasConstruccion.details"
                                        class="custom-print-table">
                                        <ng-container matColumnDef="linea">
                                            <th mat-header-cell *matHeaderCellDef>Línea</th>
                                            <td mat-cell *matCellDef="let element">{{ element.linea }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="clase">
                                            <th mat-header-cell *matHeaderCellDef>Clase</th>
                                            <td mat-cell *matCellDef="let element">{{ element.clase }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="calidad">
                                            <th mat-header-cell *matHeaderCellDef>Calidad</th>
                                            <td mat-cell *matCellDef="let element">{{ element.calidad }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="cantidad">
                                            <th mat-header-cell *matHeaderCellDef>Cantidad</th>
                                            <td mat-cell *matCellDef="let element">{{ element.cantidad | number: '1.0-0'
                                                }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="anioConstruccion">
                                            <th mat-header-cell *matHeaderCellDef>Año de construcción</th>
                                            <td mat-cell *matCellDef="let element">{{ element.anioConstruccion }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="avaluoLinea">
                                            <th mat-header-cell *matHeaderCellDef>Avalúo linea</th>
                                            <td mat-cell *matCellDef="let element">${{ element.avaluoLinea | number:
                                                '1.0-0' }}</td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="lineasConstruccionDisplayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: lineasConstruccionDisplayedColumns;">
                                        </tr>

                                        <tr class="mat-mdc-row" *matNoDataRow>
                                            <td class="mat-mdc-cell text-center font-weight-500"
                                                [attr.colspan]="lineasConstruccionDisplayedColumns.length">
                                                No hay datos disponibles
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>

        </div>
    </mat-card-content>
</mat-card>